import { Stack, Text } from "@mantine/core";
import type { AssistantUsageText } from "@/locales/assistant-usage";
import type { ModelRateDto, ModelRateUpdate } from "@/types/ai-assistant-usage";
import { CapRateRow } from "./cap-rate-row";

interface Props {
	rates: ModelRateDto[];
	t: AssistantUsageText;
	disabled: boolean;
	onSave: (model: string, body: ModelRateUpdate) => Promise<void>;
}

/** Daftar tarif per model; admin mengisi tarif Claude di sini (tidak ada tarif bawaan untuk Claude). */
export function CapRatesEditor({ rates, t, disabled, onSave }: Props) {
	return (
		<Stack gap="xs" data-usage-rates>
			<Text size="sm" fw={600}>
				{t.ratesTitle}
			</Text>
			<Text size="xs" c="dimmed">
				{t.ratesHint}
			</Text>
			<Stack gap="sm">
				{rates.map((r) => (
					<CapRateRow
						key={r.model}
						rate={r}
						t={t}
						disabled={disabled}
						onSave={onSave}
					/>
				))}
			</Stack>
		</Stack>
	);
}
